import { render, staticRenderFns } from "./ClassificationViewer.vue?vue&type=template&id=e860f178&"
import script from "./ClassificationViewer.vue?vue&type=script&lang=js&"
export * from "./ClassificationViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports